import React from 'react';
import { Status } from 'reapop';

import {
  NotificationErrorIcon as ErrorIcon,
  NotificationSuccessIcon as SuccessIcon,
  NotificationWarningIcon as WarningIcon,
  PointUpIcon,
  ServiceIcon,
} from '#web-components/components/Icons';

interface FlashMessageIconProps {
  status: Status | 'service';
  customIcon?: React.ElementType;
  className?: string;
}

const FlashMessageIcon: React.FC<FlashMessageIconProps> = (props: FlashMessageIconProps) => {
  const { status, customIcon: CustomIcon, className = undefined } = props;

  if (CustomIcon) {
    return <CustomIcon className={className} />;
  }

  switch (status) {
    case 'info':
      return <PointUpIcon size={36} className={className} />;
    case 'error':
      return <ErrorIcon variant="h4" className={className} />;
    case 'warning':
      return <WarningIcon size={36} className={className} />;
    case 'success':
      return <SuccessIcon size={36} className={className} />;
    case 'service':
      return <ServiceIcon variant="h4" className={className} />;
    default:
      return null;
  }
};

export default FlashMessageIcon;
